/**
 * MetricBarCard 组件工具函数
 */
import dataFormat from '@home/utils/dbDataFormat/dataFormat';
import type { IMetricConfig, TFormatter } from './_type';
import { dynamicString } from '@home/utils/dynamicString';

/**
 * 执行格式化函数
 * @param formatter - 格式化器（字符串格式规则或函数）
 * @param value - 待格式化的值
 * @returns 格式化后的字符串
 */
export const executeFormatter = (
  formatter: TFormatter | undefined,
  value: number | string
): string => {
  if (!formatter) {
    if (value === null || value === undefined || value === '') return '-';
    return String(value);
  }

  if (typeof formatter === 'function') {
    try {
      return formatter(value);
    } catch (error) {
      console.error('Formatter function error:', error);
      return String(value);
    }
  }

  if (typeof formatter === 'string') {
    try {
      return dataFormat({ value, formatRule: formatter });
    } catch (error) {
      console.error('DataFormat error:', error);
      return String(value);
    }
  }

  return String(value);
};

/**
 * 格式化指标值
 * @param config - 指标配置
 * @param value - 待格式化的值
 * @returns 格式化后的字符串
 */
export const formatMetricValue = (
  config: IMetricConfig | null,
  value: number | string,
  data?: any,
): string => {
  if (!config) return '-';
  if (value === null || value === undefined || value === '') return '-';
  const formatter = data ?  dynamicString(config?.formatter as string, data) : config.formatter;
  if(config?.moreThan100Show100 && Number(value) >= 1) {
    return executeFormatter(formatter, 1);
  }
  return executeFormatter(formatter, value);
};
